import React from "react";
import {
  Badge, BottomNavigation, BottomNavigationAction, Box, IconButton, Paper, Stack, Typography
} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Cancel01Icon, Clock01Icon, DialpadCircle01Icon, UserGroupIcon} from "@hugeicons/core-free-icons";
import {useNavigate} from "react-router-dom";
import {useRegistryProject} from "../../pages/registry-project/RegistryProjectContext";
import {ActiveCallCard} from "./ActiveCallCard";
import {PhoneCallsTab} from "./PhoneCallsTab";
import {PhoneDialTab} from "./PhoneDialTab";
import {PhoneQueueTab} from "./PhoneQueueTab";

const navActionSx = {
  minWidth: 0, color: "#8A8AA0",
  "&.Mui-selected": {color: "#4B55C9"},
  "& .MuiBottomNavigationAction-label, & .MuiBottomNavigationAction-label.Mui-selected": {fontSize: 11, fontWeight: 600},
};

// The browser phone, laid out like a phone app: calls, dial pad and queue behind a bottom navigation. Full screen on
// phones, above the green button otherwise. tab: calls | dial | queue. queue: see useAgentQueue.
export const PhonePanel = ({tab, onChangeTab, onClose, queue}) => {
  const {basePath} = useRegistryProject();
  const navigate = useNavigate();

  const openConversation = (conversationId) => {
    onClose();
    navigate(`${basePath}/supervision?conversation=${encodeURIComponent(conversationId)}`);
  };

  return (
    <Paper elevation={0} role={"dialog"} aria-label={"Phone"} sx={{
      position: "fixed", zIndex: 1200, display: "flex", flexDirection: "column", overflow: "hidden", bgcolor: "#fff",
      inset: {xs: 0, md: "auto 28px 96px auto"},
      width: {xs: "100%", md: 360},
      height: {xs: "100%", md: "min(620px, calc(100vh - 128px))"},
      borderRadius: {xs: 0, md: "20px"},
      border: {xs: "none", md: "1px solid #ECECF3"},
      boxShadow: {xs: "none", md: "0 16px 48px rgba(35, 38, 77, 0.18)"},
    }}>
      <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} sx={{
        px: 2, py: 1, flexShrink: 0, borderBottom: "1px solid #F0F0F6",
      }}>
        <Typography sx={{fontSize: 16, fontWeight: 700, color: "#23264D"}}>
          {{calls: "Calls", dial: "Dial", queue: "Queue"}[tab]}
        </Typography>
        <IconButton aria-label={"Close the phone"} size={"small"} onClick={onClose} sx={{color: "#4A4A63"}}>
          <HugeiconsIcon icon={Cancel01Icon} size={18}/>
        </IconButton>
      </Stack>

      <ActiveCallCard onOpened={onClose}/>

      <Box sx={{flex: 1, minHeight: 0, display: "flex", flexDirection: "column"}}>
        {tab === "calls" && <PhoneCallsTab onOpenConversation={openConversation}/>}
        {tab === "dial" && <PhoneDialTab/>}
        {tab === "queue" && <PhoneQueueTab queue={queue} onOpenConversation={openConversation}/>}
      </Box>

      <BottomNavigation
        showLabels value={tab} onChange={(e, value) => onChangeTab(value)}
        sx={{flexShrink: 0, height: 60, borderTop: "1px solid #F0F0F6"}}
      >
        <BottomNavigationAction value={"calls"} label={"Calls"} sx={navActionSx} icon={<HugeiconsIcon icon={Clock01Icon} size={22}/>}/>
        <BottomNavigationAction value={"dial"} label={"Dial"} sx={navActionSx} icon={<HugeiconsIcon icon={DialpadCircle01Icon} size={22}/>}/>
        <BottomNavigationAction value={"queue"} label={"Queue"} sx={navActionSx} icon={
          <Badge badgeContent={queue.count} max={99} sx={{"& .MuiBadge-badge": {color: "#fff", bgcolor: "#A86A0C"}}}>
            <HugeiconsIcon icon={UserGroupIcon} size={22}/>
          </Badge>
        }/>
      </BottomNavigation>
    </Paper>
  );
};
